// @generated by TypeGen from LogbookModel/Status.swift - DO NOT EDIT

import type { IAuditLogEdit } from "./AuditLogEdit"
import type { ILogbookModel } from "./Model"
import type { IAlertStatusData } from "./Status/AlertStatus"
import type { IDataRecordStatusData } from "./Status/DataRecordStatus"
import type { IEngineStatusData } from "./Status/EngineStatus"
import type { IGeneratorStatusData } from "./Status/GeneratorStatus"
import type { ILightingStatusData } from "./Status/LightingStatus"
import type { IManualShipStatusData } from "./Status/ManualShipStatus"
import type { IMonitorStatusData } from "./Status/MonitorStatus"
import type { INMEAConnectionStatusData, INMEAStatusData } from "./Status/NMEAStatus"
import type { ISailsStatusData } from "./Status/SailsStatus"
import type { IShipStatusData } from "./Status/ShipStatus"
import type { ITestStatusData } from "./Status/TestStatus"

export interface IStatus extends ILogbookModel {
  id: number;
  cruiseId: number;
  tripId: number;
  dayId: number;
  accountId: number;
  shipId: number;
  userId?: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  deletedAt?: string;
  endLogId?: number;
  startLogId: number;
  data: string;
  item?: number;
  name?: string;
  statusType: IStatusType;
  value: number;
}

export interface IStatusResponse {
  status: IStatus;
  auditLogEdits: IAuditLogEdit[];
}

export enum IStatusType {
  ship = 1,
  nmea = 2,
  engine = 3,
  sails = 4,
  lighting = 5,
  alert = 6,
  generator = 7,
  monitor = 8,
  dataRecord = 9,
  nmeaConnection = 10,
  manualShipStatus = 11,
  test = 100,
}

export interface IStatusDataMap {
  [IStatusType.ship]: IShipStatusData;
  [IStatusType.nmea]: INMEAStatusData;
  [IStatusType.engine]: IEngineStatusData;
  [IStatusType.sails]: ISailsStatusData;
  [IStatusType.lighting]: ILightingStatusData;
  [IStatusType.alert]: IAlertStatusData;
  [IStatusType.generator]: IGeneratorStatusData;
  [IStatusType.monitor]: IMonitorStatusData;
  [IStatusType.dataRecord]: IDataRecordStatusData;
  [IStatusType.nmeaConnection]: INMEAConnectionStatusData;
  [IStatusType.manualShipStatus]: IManualShipStatusData;
  [IStatusType.test]: ITestStatusData;
}

export type IStatusParsed = { [K in IStatusType]: Omit<IStatus, "data"> & { statusType: K; dataParsed: IStatusDataMap[K] } }[IStatusType];

export const Status = {
  parse(r: IStatus): IStatusParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as IStatusParsed;
  },
};
